import { GlAnimatedSidebarIcon, GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { mapActions, mapState } from '../../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import { __ } from '~/locale';
import { useFileBrowser } from '../../../diffs/stores/file_browser.js?vue3';
export default {
    name: 'FileBrowserDrawerToggle',
    components: {
        GlButton,
        GlAnimatedSidebarIcon
    },
    computed: {
        ...mapState(useFileBrowser, [
            'fileBrowserDrawerVisible'
        ]),
        toggleFileBrowserTitle () {
            return this.fileBrowserDrawerVisible ? __('Hide file browser') : __('Show file browser');
        }
    },
    methods: {
        ...mapActions(useFileBrowser, [
            'toggleFileBrowserDrawerVisibility'
        ])
    }
};
